import { isClient } from "../../../../../utils";

export const updateStickyNavOffset = (): void => {
    // Ensure that the header height is recalculated when the component mounts
    if (isClient) {
        const header = document.querySelector("header");
        const navs = document.querySelectorAll("nav");
        if (header || navs) {
            const headerHeight = header ? header.offsetHeight : 0;
            const navHeight = Array.from(navs)
                .filter(
                    (nav) =>
                        !nav.id.includes("side-nav") &&
                        (!header || !header.contains(nav))
                )
                .reduce((total, n) => total + n.offsetHeight, 0);
            document.documentElement.style.setProperty(
                "--wae-header-height",
                `${headerHeight + navHeight}px`
            );
        }
    }
};

// example usage in UniformContainer component:
//
// useEffect(() => {
//     updateStickyNavOffset();
// }, []);
